<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        class: {
            type: String
        },
        modelValue: {
            type: Boolean
        },
    },
    data() {
        return {
            tosLink: '',
            privacyLink: ''
        }
    },
    emits: [
        'update:modelValue'
    ],
    mounted() {
        this.tosLink = this.$page.props.locale == 'hu' ? '/storage/docs/terms-and-conditions-hu.pdf' : '/storage/docs/terms-and-conditions-en.pdf';
        this.privacyLink = this.$page.props.locale == 'hu' ? '/storage/docs/privacy-policy-hu.pdf' : '/storage/docs/privacy-policy-en.pdf';
    }
}
</script>
<template>
    <input class="form-check-input" :class="class" type="checkbox" :id="id" :value="modelValue" @change="$emit('update:modelValue', $event.target.checked)" :checked="modelValue">
    <label class="form-check-label" :for="id"
        v-html="$t('Ezennel megerősítem, hogy a fenti információt elolvastam és megértettem, illetve a miniBUD :tosStartÁltalános Szerződési Feltételeit:tosEnd és :privacyStartAdatvédelmi Szabályzatát:privacyEnd elfogadom. Tudomásul veszem, hogy a hamis vagy helytelen adatok megadása a miniBUD szolgáltatásai nyújtásának megtagadását eredményezheti.', { privacyStart: '<a target=\'_blank\' href=\'' + privacyLink + '\'>', privacyEnd: '</a>', tosStart: '<a target=\'_blank\' href=\'' + tosLink + '\'>', tosEnd: '</a>' })">
    </label>
</template>
